/*
 * @description: 跳转到登录页
 * @Author: wxy
 * @Date: 2019-01-18 13:26:54
 */
import router from '../router'
export function toLogin(to) {
  if (to) {
    let toPath = `${location.protocol}//${location.host}${location.pathname}#${to.fullPath}`
    router.push({ path: '/login', query: { redirectURL: toPath } })
  } else {
    router.push('/login')
  }
}



// WEBPACK FOOTER //
// ./src/utils/toLogin.js